'use client';

import { usePathname } from 'next/navigation';
import { PAGES } from '@/lib/config';

const STEPS = [
  PAGES.TEAM_SELECTION,
  PAGES.PREDICTOR,
  PAGES.ENTRY,
  PAGES.SURVEY,
  PAGES.CONFIRM,
] as const;

export default function ProgressBar() {
  const pathname = usePathname();
  const step = STEPS.indexOf(pathname as (typeof STEPS)[number]);

  if (step < 0) {
    return null;
  }

  const pct = (step / (STEPS.length - 1)) * 100;

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
      className="fixed top-0 right-0 left-0 z-50 h-[3px] bg-bg-surface-2"
    >
      <div
        className="h-full bg-accent transition-[width] duration-400 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
